<template>
    <div class="templete_box">
        <div class="templete no_print">
            <div class="search_box search_box_f clearfix">
                <div class="search_time search_inputBox">
                    <el-date-picker v-model="sales_start" @keyup.enter.native="getList(true)" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="销售开始"></el-date-picker>
                    ~
                    <el-date-picker v-model="sales_end" @keyup.enter.native="getList(true)" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="销售结束"></el-date-picker>
                </div>
                <div class="search_time search_inputBox">
                    <el-date-picker v-model="out_start" @keyup.enter.native="getList(true)" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="出库开始"></el-date-picker>
                    ~
                    <el-date-picker v-model="out_end" @keyup.enter.native="getList(true)" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="出库结束"></el-date-picker>
                </div>
                <el-input class="search_input search_inputBox" @keyup.enter.native="getList(true)" v-model="params.search.bale_no" placeholder="捆包号"></el-input>
                <select-down-customer ref="selectdowncustomer" @keyup.enter.native="getList(true)" class="searchCustomer" @changeselect="res=>{this.params.search.customer_id = res;}"></select-down-customer>
                <el-select class="search_select search_inputBox" @keyup.enter.native="getList(true)" v-model="params.search.salesman_id" multiple collapse-tags placeholder="销售人" filterable @visible-change="getSelectList('user')">
                    <el-option v-for="list in selectMap.user" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" @keyup.enter.native="getList(true)" v-model="params.search.order_sn" placeholder="销售单号"></el-input>
                <!-- <el-select class="search_select search_inputBox" v-model="params.search.brand_id" placeholder="品牌">
                    <el-option v-for="list in brandList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select> -->
                <el-select class="search_select search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.search.breed_id" multiple collapse-tags placeholder="品名" filterable @visible-change="getSelectList('breed')">
                    <el-option v-for="list in selectMap.breed" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.search.brand_id" multiple collapse-tags placeholder="品牌" filterable @visible-change="getSelectList('brand')">
                    <el-option v-for="list in selectMap.brand" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.search.sales_thickness" placeholder="厚度"></el-input>
                <el-input class="search_input search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.search.sales_length" placeholder="长度"></el-input>
                <el-select class="search_select search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.search.grade_id" multiple collapse-tags placeholder="等级" filterable>
                    <el-option v-for="list in gradeList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.search.the_type" placeholder="单据类型">
                    <el-option :value="999" :label="'全部单据类型'"></el-option>
                    <el-option :value="1" :label="'销售记录'"></el-option>
                    <el-option :value="2" :label="'退货记录'"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.search.remark" placeholder="备注"></el-input>
                <el-input class="search_input search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.search.remark_1" placeholder="备注1"></el-input>
                <el-input class="search_input search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.search.contract_no" placeholder="合同号"></el-input>
                <el-input class="search_input search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.search.original_bale" placeholder="供单号"></el-input>
                <el-input class="search_input search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.search.bill_lading_no" placeholder="提单号"></el-input>
                <el-input class="search_input search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.search.ship_no" placeholder="船名"></el-input>
                <el-input class="search_input search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.search.batch_no" placeholder="批次号"></el-input>
                <!-- <el-input class="search_input search_inputBox" v-model="params.search.sales_start" placeholder="包号"></el-input> -->
                <el-select class="search_select search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.search.warehouse_id" placeholder="仓库" filterable @visible-change="getSelectList('warehouse')">
                    <el-option v-for="list in selectMap.warehouse" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.search.opening_company_id" placeholder="货权单位" filterable @visible-change="getSelectList('opencompany')">
                    <el-option v-for="list in selectMap.opencompany" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-if="isShowMore" v-model="params.search.attribute_id" multiple collapse-tags placeholder="属性" @visible-change="getSelectList('attribute')">
                    <el-option v-for="list in selectMap.attribute" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-if="isShowMore" v-model="params.search.color_id" multiple collapse-tags placeholder="选色" filterable @visible-change="getSelectList('color')">
                    <el-option v-for="list in selectMap.color" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.search.supplier_id" placeholder="供应商" multiple filterable @visible-change="getSelectList('supplier')">
                    <el-option v-for="list in selectMap.supplier" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <div class="search_time search_inputBox" v-if="isShowMore">
                    <el-date-picker v-model="start_audit_time" @keyup.enter.native="getList(true)" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="开始审核日期"></el-date-picker>
                    ~
                    <el-date-picker v-model="end_audit_time" @keyup.enter.native="getList(true)" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="结束审核日期"></el-date-picker>
                </div>
                <div class="searchBtnList clearfix">
                    <div class="reset fcolor" @click="isShowMore=!isShowMore">{{isShowMore?'收起':'更多'}}</div>
                    <div class="reset fcolor" @click="reset">重置</div>
                    <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
                </div>
                <div class="execlInsert execlInsertHasFilter clearfix">
                    <div class="sousuoBtn" @click="openSou"></div>
                    <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
                    <span class="excel_btn" @click="excelExport"><i class="excel-icon"></i>excel导出</span>
                </div>
            </div>
            <div class="btnList clearfix">
                <el-button class="funcPublicBtn" v-if="module.indexOf(',sell-report-statistic-return,')!=-1" @click="backPro">申请退货</el-button>
                <el-button class="funcPublicBtn" v-if="module.indexOf(',sell-report-price-update,')!=-1" @click="batchEdit">批量修改</el-button>
                <div class="upimgBtnBox">
                    <el-tooltip class="item" effect="dark" placement="bottom">
                        <div slot="content">
                            <span>注:</span><br/>
                            <span>1.销售统计（销售）:是销售单"财务审核"通过后统计的数据</span><br/>
                            <span>2.销售汇总（销售）:是销售单"财务审核"通过后统计的数据</span><br/>
                            <span>3.销售利润表（财务）:是销售单"财务审核"通过后统计的数据</span><br/><br/>
                        </div>
                        <div class="tipImg" :label="0"  border></div>
                    </el-tooltip>
                </div>
            </div>
            <div class="tableBox">
                <tabletem :isSetCol="true" scene="sales.statistics" :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @getRow="getRow" @rowClick="rowClick" @sortTable="sortList"></tabletem>
                 <!-- @getRow="getRow" @getTableDelete="getTableDelete" @getTableSee="getTableSee" @getTableEdit="getTableEdit" @rowClick="rowClick" -->
            </div>
            <div class="totalCal">
                <div class="totalName">合计：</div>
                <div class="totalNumber" v-if="totalObj.out_cube||Number(totalObj.out_cube)==0">出库方数:{{totalObj.out_cube}}</div>
                <div class="totalNumber" v-if="totalObj.sales_cube||Number(totalObj.sales_cube)==0">销售方数:{{totalObj.sales_cube}}</div>
                <div class="totalNumber" v-if="totalObj.sales_amount||Number(totalObj.sales_amount)==0">
                    <div class="contractLabel">
                        <div class="labelTip">
                            <div class="laCbelTipC">
                                销售立方*销售单价
                            </div>
                        </div>
                        <span>销售金额:{{totalObj.sales_amount}}</span>
                    </div>
                </div>
                <div class="totalNumber" v-if="totalObj.purchase_amount||Number(totalObj.purchase_amount)==0">
                    <div class="contractLabel">
                        <div class="labelTip">
                            <div class="laCbelTipC">
                                出库立方*采购单价
                            </div>
                        </div>
                        <span>采购金额:{{totalObj.purchase_amount}}</span>
                    </div>
                </div>
                <div class="totalNumber" v-if="totalObj.cost_amount||Number(totalObj.cost_amount)==0">
                    <div class="contractLabel">
                        <div class="labelTip" style="width:280px">
                            <div class="laCbelTipC">
                                出库立方*费用平摊单价=费用金额
                            </div>
                        </div>
                        <span>成本费用:{{totalObj.cost_amount}}</span>
                    </div>
                </div>
                <!-- <div class="totalNumber" v-if="totalObj.business_expense||Number(totalObj.business_expense)==0">
                    <div class="contractLabel">
                        <div class="labelTip" style="width:210px">
                            <div class="laCbelTipC">
                                费用管理已审核的营业支出
                            </div>
                        </div>
                        <span>营业支出:{{totalObj.business_expense}}</span>
                    </div>
                </div> -->
                <div class="totalNumber" v-if="totalObj.warehouse_cost_amount||Number(totalObj.warehouse_cost_amount)==0">
                    <div class="contractLabel">
                        <div class="labelTip">
                            <div class="laCbelTipC">
                                仓储费单价*码单立方
                            </div>
                        </div>
                        <span>仓储费:{{totalObj.warehouse_cost_amount}}</span>
                    </div>
                </div>
                <div class="totalNumber" v-if="totalObj.tax_manual||Number(totalObj.tax_manual)==0">
                    <div class="contractLabel">
                        <div class="labelTip" style="width:140px">
                            <div class="laCbelTipC">
                                应收管理添加
                            </div>
                        </div>
                        <span>含税价税金:{{totalObj.tax_manual}}</span>
                    </div>
                </div>
                <div class="totalNumber" v-if="totalObj.business_expense||Number(totalObj.business_expense)==0">
                    <div class="contractLabel">
                        <div class="labelTip" style="width:280px">
                            <div class="laCbelTipC">
                                关联销售单已审核的营业支出费用
                            </div>
                        </div>
                        <span>销售费用:{{totalObj.business_expense}}</span>
                    </div>
                </div>
                <div class="totalNumber" v-if="totalObj.reduce_amount||Number(totalObj.reduce_amount)==0">
                    <div class="contractLabel">
                        <div class="labelTip" style="width:210px"> 
                            <div class="laCbelTipC">
                                应收管理销售单结算优惠
                            </div>
                        </div>
                        <span>优惠金额:{{totalObj.reduce_amount}}</span>
                    </div>
                </div>
                <div class="totalNumber" v-if="totalObj.other_business_expense||Number(totalObj.other_business_expense)==0">
                    <div class="contractLabel">
                        <div class="labelTip" style="width:280px">
                            <div class="laCbelTipC">
                                与销售单无关已审核的营业支出费用
                            </div>
                        </div>
                        <span>其他支出:{{totalObj.other_business_expense}}</span>
                    </div>
                </div>
                <div class="totalNumber" v-if="totalObj.flip_profit||Number(totalObj.flip_profit)==0">
                    <div class="contractLabel">
                        <div class="labelTip" style="width:320px">
                            <div class="laCbelTipC" >
                               订单已完成的原料成本金额-成品采购金额
                            </div>
                        </div>
                        <span>加工盈亏:{{totalObj.flip_profit}}</span>
                    </div>
                </div>
                <div class="totalNumber" v-if="totalObj.sales_margin_a||Number(totalObj.sales_margin_a)==0">
                    <div class="contractLabel">
                        <div class="labelTip" style="width:350px">
                            <div class="laCbelTipC" >
                                销售金额-采购金额-成本费用-仓储费-销售费用
                            </div>
                        </div>
                        <span>销售毛利:{{totalObj.sales_margin_a}}</span>
                    </div>
                </div>
                <div class="totalNumber" v-if="totalObj.sales_margin||Number(totalObj.sales_margin)==0">
                    <div class="contractLabel">
                        <div class="labelTip"  style="width:430px">
                            <div class="laCbelTipC">
                                销售金额-采购金额-成本费用-仓储费-含税价税金-销售费用-优惠金额
                            </div>
                        </div>
                        <span>销售利润:{{totalObj.sales_margin}}</span>
                    </div>
                </div>
                <div class="totalNumber" v-if="totalObj.company_margin||Number(totalObj.company_margin)==0">
                    <div class="contractLabel">
                        <div class="labelTip" style="width:250px">
                            <div class="laCbelTipC">
                                销售金额-采购金额-成本费用-仓储费-含税价税金-销售费用-优惠金额-其他支出-加工盈亏
                            </div>
                        </div>
                        <span>公司利润:{{totalObj.company_margin}}</span>
                    </div>
                </div>
                <div class="totalNumber" v-if="totalObj.company_margin_rate||Number(totalObj.company_margin_rate)==0">
                    <div class="contractLabel">
                        <div class="labelTip" style="width:220px">
                            <div class="laCbelTipC">
                               公司利润÷销售金额*100
                            </div>
                        </div>
                        <span>利润率:{{totalObj.company_margin_rate}}</span>
                    </div>
                </div>
            </div>
            <div class="pageBox">
                <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
            </div>
        </div>
        <!-- dialog START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisible" class="eldialog eldialogC eldialogWidth" :modal="false" title="销售退货申请单" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <div class="eldialogTopMess dialogForm editPersonBoxTop clearfix">
                    <div class="topMess">客户： {{form_params.customer}}</div>
                    <div class="topMess">销售单号： {{form_params.order_sn}}</div>
                    <div class="topMess">退货日期： 
                        <el-date-picker  v-model="form_params.return_time" type="date" size="mini" style="width: 125px;" :picker-options="expireTimeOption"></el-date-picker>
                    </div>
                    <div class="topMess recMess">
                        <div class="recLable">REC：</div>
                        <div class="recCom">
                            <el-checkbox  class="taxCheck" v-model="form_params.rec"></el-checkbox>
                            <div class="taxDiv" v-if="form_params.rec==true">
                                <el-select class="taxTypeSelect" placeholder="fx" v-model="form_params.rec_type">
                                    <el-option :value="1" label="×"></el-option>
                                    <el-option :value="2" label="÷"></el-option>
                                </el-select>
                                <!-- <el-input class="taxInput" v-model="form_params.tax_rate" v-digits:2="form_params.tax_rate" placeholder="税率" ></el-input>
                                <span class="taxSpan">%</span> -->
                                <el-input class="taxInput" v-model="form_params.tax_rate" v-digits:2="form_params.tax_rate" placeholder="税率"  >
                                        <template slot="suffix"><span class="sizefh">%</span></template>
                                </el-input>
                            </div>
                        </div>
                    </div>
                    <div class="globalFilterBtn"  @click="filterdetailsVisible=!filterdetailsVisible;"></div>
                </div>
                <div class="dialogFlow">
                    <div class="editBox">
                        <div class="editList">
                            <el-table :data="listDetail" :summary-method="getTableSummaries" border stripe show-summary highlight-current-row size="mini" height="100%"  @header-dragend="headDrog">
                                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                                <template v-for="(item) in filters">
                                    <el-table-column :prop="item.field" v-if="item.show && billColumn.includes(item.field)" :key="item.field" :label="item.name"
                                                :sortable="false"
                                                :width="item.width && item.width>0 ?item.width:80+ 'px'"
                                                align="left"
                                                show-overflow-tooltip
                                            >
                                        <template slot-scope="scope">
                                            <div v-if="item.field == 'sales_width_total'">
                                                    <span @click="widthList = scope.row.sales_width;saleDialogVisibleWidth=true;isSaleCanEditTotalWidth=false;" style="text-decoration:underline;cursor:pointer;">
                                                        {{ scope.row.sales_width_total }}
                                                    </span>
                                            </div>
                                            <div v-else-if="item.field == 'return_width_total'">
                                                    <span @click="returnWidthClick(scope.row,scope.$index)" style="text-decoration:underline;cursor:pointer;">
                                                        {{ scope.row.return_width_total }}
                                                    </span>
                                            </div>
                                            <div v-else-if="item.field == 'return_pieces'">
                                                 <el-input type="text" v-model="scope.row.return_pieces" :disabled="scope.row.category==2"></el-input>
                                            </div>
                                            <div v-else-if="item.field == 'return_cube'">
                                                  <el-input type="text" v-model="scope.row.return_cube" :disabled="scope.row.category==2" @input.native="changeDetailTotalPrice($event,scope.row.return_cube)"></el-input>
                                            </div>
                                            <div  v-else-if="item.field == 'totalPrice'">
                                                 {{ scope.row.totalPrice }}
                                            </div>
                                            <span v-else>
                                                {{ scope.row[item.field] }}
                                            </span>
                                        </template>
                                    </el-table-column>
                                </template>
                            </el-table>
                            <!-- <el-table :data="listDetail" border stripe show-summary highlight-current-row size="mini" height="100%">
                                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                                <el-table-column label="操作"  width="75">
                                    <template slot-scope="scope">
                                        <div class="icon_wrap">
                                            <i class="operation_add" @click="dialogVisibleStock=!dialogVisibleStock" title="添加"></i>
                                            <i class="operation_delete" v-if="listDetail.length>1" @click="listDetailDelete(scope.$index)" title="删除"></i>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column label="捆包号" width="110" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.bale_no }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="品牌" width="80" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.brand }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="品名" width="80" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.breed }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="等级" width="60" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.grade }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="厚度" width="60" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.sales_thickness }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="长度" width="60" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.sales_length }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="总宽度" width="60" show-overflow-tooltip v-if="boardAfricaType">
                                    <template slot-scope="scope">
                                        <span @click="widthList = scope.row.sales_width;dialogVisibleWidth=true;" style="text-decoration:underline;cursor:pointer;">
                                            {{ scope.row.sales_width_total }}
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="片数" width="50" show-overflow-tooltip v-if="boardAmericaType">
                                    <template slot-scope="scope">
                                        {{ scope.row.pieces }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="层数" width="80" show-overflow-tooltip v-if="boardAfricaType">
                                    <template slot-scope="scope">
                                        {{ scope.row.layer_number }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="销售立方" prop="sales_cube" width="80" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.sales_cube }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="退货片数" width="80" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <el-input type="text" v-model="scope.row.return_pieces"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column label="退货立方" prop="return_cube" width="80" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <el-input type="text" v-model="scope.row.return_cube"  @input.native="changeDetailTotalPrice($event,scope.row.return_cube)"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column label="销售单价" width="80" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.sales_price }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="退货金额(￥)" prop="totalPrice" width="100" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.totalPrice }}
                                    </template>
                                </el-table-column>
                            </el-table> -->
                        </div>
                    </div>
                    <div class="dialogTotal clearfix">
                        <div class="dialogTotalC">合计应退：</div>
                        <div class="dialogTotalC">退货金额:{{tableTotal.totalPrice}}</div>
                        <div class="dialogTotalC" v-if="form_params.rec==true&&Number(tableTotal.tax_amount)">税金:{{tableTotal.tax_amount}}</div>
                        <div class="dialogTotalC" v-if="Number(tableTotal.refundableAmount)">应退金额:{{tableTotal.refundableAmount}}</div>
                    </div>
                    <div class="remarkBox remarkBoxFourText">
                        <textarea class="remarkTextarea" v-model="form_params.remark" cols="5"></textarea>
                    </div>
                </div>
                <div class="editPersonBox clearfix">
                    <div class="editPerson">制单人：{{form_params.create_name}}</div>
                    <div class="editPerson">审核人：</div>
                    <!-- <div class="editPerson">打印时间：{{parseInt(new Date().getTime()/1000) | dateFormat_}}</div> -->
                </div>
                <div class="editBtnList clearfix">
                    <div style="float:left;margin-bottom: 10px;">
                        <el-button class="funcPublicBtnEdit" style="line-height: 25px;" @click="openbusinessRelation">关联退货费用</el-button>
                        <div v-if="newFee.length>0" class="clearfix" style="float:left;">
                            <div class="newFee" v-for="(list,index) in newFee" :key="'_'+index">
                                {{list.fee_name+':  ￥'+list.amount}}
                                <img src="../../assets/top-delete-suspension.png" v-if="!detailInfo.id" class="newFeeImg" @click="delOutFee(index)"/>
                                <img src="../../assets/top-delete-suspension.png" v-else-if="detailInfo.isDeleteFee==1" class="newFeeImg" @click="isDeleteFee(list.id)"/>
                            </div>
                        </div>
                    </div>
                    <div class="editBtn">
                        <el-button class="funcPublicBtn" @click="dialogVisible=!dialogVisible">取消</el-button>
                        <el-button class="funcPublicBtn funcPublicBtnChecked" @click="backConfirm">提交审核</el-button>
                    </div>
                </div>
            </div>
        </el-dialog>
        <!-- dialog END -->
        <!-- 宽度列表START -->
        <el-dialog  v-dialog-drag:visible.sync="dialogVisibleWidth" class="eldialog totalWidthDialog" width="820px" :modal="false" custom-class="full_dialog">
            <total-widthnew :edit="false" :list="widthList" @cancelWidth="()=>{this.dialogVisibleWidth = false;}"></total-widthnew>
        </el-dialog>
        <!-- 宽度列表END -->
        <!-- 销售宽度列表START -->
        <el-dialog v-dialog-drag :visible.sync="saleDialogVisibleWidth" class="eldialog totalWidthDialog" width="820px" :modal="false" custom-class="full_dialog">
            <total-widthnew :edit="isSaleCanEditTotalWidth" :dialogvisible="saleDialogVisibleWidth" :list="widthList" @returnwidth="res=>{saleWidthReturn(res)}" @cancelWidth="()=>{this.saleDialogVisibleWidth = false;}"></total-widthnew>
        </el-dialog>
        <!-- 销售宽度列表END -->
        <!-- 退货宽度列表START -->
        <el-dialog v-dialog-drag :visible.sync="returnDialogVisibleWidth" class="eldialog totalWidthDialog" width="820px" :modal="false" custom-class="full_dialog">
            <total-widthnew :edit="isreturnCanEditTotalWidth" :editReturn="editReturn" :dialogvisible="returnDialogVisibleWidth" :list="widthList" @returnwidth="res=>{returnWidthReturn(res)}" :type="4"  @cancelWidth="()=>{this.returnDialogVisibleWidth = false;}"></total-widthnew>
        </el-dialog>
        <!-- 退货宽度列表END -->
        <!-- 字段过滤 START -->
        <filter-fields :tableData="filter" scene="sales.statistics" :isGlobal="isGlobal" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
        <filter-fields :tableData="filter" scene="return.create.column" :isGlobal="isGlobal" :filterDialogVisible="filterdetailsVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterdetailsVisible = val;}"></filter-fields>
        <!-- 字段过滤 END -->
        <!-- 销售修改 START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisibleChange" class="eldialog eldialogLine" width="200px" :modal="false" title="销售结果修正" custom-class="full_dialog">
            <div class="">
                <el-form class="dialogFormB clearfix">
                    <div class="eldialogFormBox">
                        <el-form-item label="采购单价：">
                            <el-input class="edit_input" v-model="changeData.cube_price" placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="销售单价：">
                            <el-input class="edit_input" v-model="changeData.sales_price" placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="出库日期：">
                            <el-date-picker v-model="changeData.out_time" value-format="yyyy-MM-dd" type="date"></el-date-picker>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
            <div class="dialogBtnList clearfix">
                <el-button  class="funcPublicBtn funcPublicBtnChecked dialogBtn" @click="changeEdit">保存</el-button>
                <el-button class="funcPublicBtn dialogBtn" @click="dialogVisibleChange = false">关闭</el-button>
            </div>
        </el-dialog>
        <!-- 销售修改 END -->
        <!-- 搜索弹框 -->
        <el-dialog title="客户搜索" :visible.sync="customerDialogVisibles" class="eldialog mark_dialog" width="350px" :modal="false" :before-close="customerCloses" v-dialogDrag>
            <div style="padding:10px;">
                <el-input placeholder="请输入客户名称" maxlength=100 v-model="params.search.customer_name"></el-input>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button class="sm_confirm_btn" type="primary" size="small" @click="Customerion()">确认</el-button>
            </span>
        </el-dialog>
        <!--添加费用START-->
        <el-dialog v-dialog-drag :visible.sync="businessRelation" class="eldialog eldialogLine" :modal="false" title="添加营业外支出费用" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <el-form ref="feeOutForm" :model="businessRelationForm" :rules="feeOutFormRlues" class="clearfix dialogFormB">
                    <el-form-item  label="日期：" prop="fee_date">
                        <el-date-picker v-model="businessRelationForm.fee_date" type="date" placeholder="" size="mini"></el-date-picker>
                    </el-form-item>
                     <el-form-item  label="销售单号：">
                        <el-input v-model="businessRelationForm.order_sn" readonly></el-input>
                    </el-form-item>
                    <el-form-item  label="费用名称：" prop="fee_id">
                        <el-select v-model="businessRelationForm.fee_id" @input="outFeeChange" @visible-change="outFeeSelectFunc" clearable>
                            <el-option v-for="list in outFeeSelect" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="收款人(单位)：" prop="payee">
                        <el-input v-model="businessRelationForm.payee"></el-input>
                    </el-form-item>
                    <el-form-item  label="金额(￥)：" prop="amount">
                        <el-input v-model="businessRelationForm.amount"></el-input>
                    </el-form-item>
                    <el-form-item  label="提供发票：" prop="is_invoice">
                        <el-select v-model="businessRelationForm.is_invoice">
                            <el-option value="1" label="是"></el-option>
                            <el-option value="0" label="否"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="备注：" prop="remark">
                        <el-input v-model="businessRelationForm.remark"></el-input>
                    </el-form-item>
                    <div class="elFormBoxBtnListCol">
                        <el-button class="funcPublicBtn" @click="businessRelation=!businessRelation" style="margin-right:15px!important;">取消</el-button>
                        <el-button class="funcPublicBtn funcPublicBtnChecked"  @click="newOutFee">确认</el-button> 
                    </div>
                </el-form>
            </div>
        </el-dialog>
        <!--添加费用END-->
    </div>
</template>
<style scoped lang="scss">
    .sizefh{font-size: 13px;padding: 5px 0;}
    .eldialogTopMess{padding:10px 0;align-items: center;justify-items: center;display: flex;
        .topMess{font-size: 14px;float: left;width: 25%;position: relative;align-items: center;justify-items: center;display: flex;}
    }
    .editPersonBox{
        .editPerson{width:33%;float: left;font-size: 12px;color:#777;box-sizing: border-box;padding:5px 0;}
    }
    .editBtnList{padding-top:10px;
        .editTax{float: left;}
        .editTaxname{float: left;font-size: 12px;color:#777;line-height: 25px;margin-right:5px;}
        .editTaxinput{float: left;width:100px;}
        .editBtn{float: right;}
    }
    .remarkBoxFourText{padding:5px 5px 5px 70px;}
    .remarkBoxFourText:before{content:"退货原因:";color: #606266;}
    .recMess{
        display: flex;
        .recCom{align-items: center;justify-items: center;flex: 1; display: flex;
        }
    }
    .taxDiv{
        margin-left: 12px;
    }
    .taxDiv /deep/ {
        display: flex;
        .taxCheck{
            z-index: 11;
        }
        .taxTypeSelect{
            width: 40px;
            // position: absolute;
            // left: 20px;
            // top: 1px;
            // z-index: 9;
            .el-input__inner{
                padding-right: 0;
                padding-left: 5px;
                font-size: 14px;
                border-right: none;
                border-top-right-radius: 0;
                border-bottom-right-radius: 0;
                height: 25px;
            }
            .el-select__caret{
                font-size: 10px;
                position: relative;
                left: 10px;
            }
        }
        .taxInput{
            width: 120px;
            .el-input__inner{
                padding-left: 10px;
                padding-right: 15px;
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;
                height: 25px;
            }
        }
        .taxSpan{
            color: red;
        }
    }
    .contractLabel{position:relative;}
    .contractLabel:hover{cursor: pointer;color: #b21111;}
    .contractLabel:hover .labelTip{display: block;}
    .labelTip{display: none;
    position: absolute;font-weight: 600;top:-65px;left:-50px;z-index:1;width:180px;
    text-align: left;border-radius: 4px;padding:10px;box-sizing: border-box;
    box-shadow: 1px 1px 5px #ccc;padding-left:30px;z-index: 100;background-color: #000;opacity: 0.8;
    color: aliceblue;}
</style>
<script>
    import bus from "../../eventBus";
    import tabletem from '../../components/table.vue'
    import pagination from '../../components/pagination.vue'
    import selectDownCustomer from '../../components/selectDownCustomer.vue'
    const initBusinessRelationForm = {
        // order_id: "",
        order_sn: "",
        fee_date: "",
        fee_id: "",
        fee_name: "",
        payee: "",
        amount: "",
        is_invoice: "",
        remark: ""
    };
    export default {
        components:{
            tabletem,
            pagination,
            selectDownCustomer
        },
        created(){
            this.sales_start = this.monthFirstDay();
            this.sales_end = new Date();
            this.getBreedList().then(res=>{
                this.breedList=res.data.data;
            })
            this.getBrandList().then(res=>{
                this.brandList=res.data.data;
            })
            this.getWarehouseList().then(res=>{
                this.warehouseList=res.data.data;
            })
            this.$getCustomerList().then(res=>{
                this.customerList=res.data.data;
            })
            this.$getSalemanList().then(res=>{
                this.saleList=res.data.data;
            })
            this.getGradeList().then(res=>{
                this.gradeList=res.data.data;
            })
            this.tableColCopy = this.$deepClone(this.tableCol);
            this.getList()
        },
        data(){
            return{
                tableLoading:false,
                module:localStorage.dw_erp_power_code,
                boardAmericaType:localStorage.dw_erp_board.indexOf("board-america")!=-1?true:false,
                boardAfricaType:localStorage.dw_erp_board.indexOf("board-africa")!=-1?true:false,
                dialogVisibleWidth:false,
                saleDialogVisibleWidth:false,//销售总宽弹框
                isSaleCanEditTotalWidth:false,
                returnDialogVisibleWidth:false,//退货总宽度弹框
                isreturnCanEditTotalWidth:false,
                editReturn:false,
                isGlobal:false,
                dialogVisibleChange:false,
                out_time:new Date(),
                changeData:{
                    ids:[],
                    out_time:"",
                    cube_price:"",
                    sales_price:"",
                },
                widthList:[],
                sales_start:"",
                sales_end:"",
                out_start:"",
                out_end:"",
                start_audit_time:"",
                end_audit_time:"",
                params:{
                    search:{
                        sales_start:"",
                        sales_end:"",
                        out_start:"",
                        out_end:"",
                        start_audit_time:"",
                        end_audit_time:"",
                        customer_id:"",
                        salesman_id:"",
                        order_sn:"",
                        breed_id:"",
                        brand_id:"",
                        grade_id:"",
                        warehouse_id:"",
                        bale_no:"",
                        contract_no:"",
                        bill_lading_no:"",
                        ship_no:"",
                        batch_no:"",
                        remark:"",
                        remark_1:"",
                        sales_length:"",
                        original_bale:"",
                        opening_company_id:"",
                        supplier_id:"", 
                        sales_thickness:"",
                        the_type:999
                    },
                    per_page: 50,
                    page:1
                },
                last_page: 10,
                current_page: 1,
                total: 1000,
                list : [],
                isShowMore : false,
                breedList:[],
                brandList:[],
                warehouseList:[],
                customerList:[],
                saleList:[],
                gradeList:[],
                selectMap:{
                    user:[],
                    breed:[],
                    brand:[],
                    customer:[],
                    opencompany:[],
                    warehouse:[],
                    supplier:[],
                    attribute:[],
                    color:[]
                },
                // dialog START
                dialogVisible : false,
                form_params:{
                    order_id:"",
                    remark:"",
                    order_sn:"",
                    customer:"",
                    rec_type:"",
                    rec:"",
                    tax_rate:"",
                    fee_list:[],
                    create_name:localStorage.dw_erp_user_name,
                    return_time:new Date(),
                },
                listDetail:[
                    { bale_no:"",brand:"",breed:"",grade:"",sales_thickness:"",sales_length:"",sales_width_total:"",sales_pieces:"",sales_cube:"",out_cube:"",return_pieces:"",return_cube:"",sales_price:""}
                ],
                // DIALOG END
                tableCol:[
                    {colName:"单据编号",colKey:"order_sn",colWidth:190,isSetWidth:true,isCanClick:false,isShow:true,isSort:true},
                    {colName:"单据日期",colKey:"sales_time",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isSort:true},
                    {colName:"审核日期",colKey:"audit_time",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isSort:true},
                    {colName:"出入库日期",colKey:"out_time",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isSort:true},
                    {colName:"单据类型",colKey:"the_type_text",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"捆包号",colKey:"bale_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"供单号",colKey:"original_bale",colWidth:65,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"客户名称",colKey:"customer_name",colWidth:170,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"供应商",colKey:"supplier",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"品名",colKey:"breed",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"销售品名",colKey:"sales_breed",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"品牌",colKey:"brand",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"等级",colKey:"grade",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"编码",colKey:"code",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"厚度",colKey:"sales_thickness",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"长度",colKey:"sales_length",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"片数",colKey:"pieces",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"层数",colKey:"layer_number",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"总宽度",colKey:"sales_width_total",colWidth:80,isSetWidth:true,isCanClick:true,isShow:true,isHideShowClickImg:true,isHideCanClickColor:true},
                    {colName:"销售立方",colKey:"sales_cube",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"检尺立方",colKey:"check_cube",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"出库立方",colKey:"out_cube",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"采购单价",colKey:"purchase_price",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"费用平摊单价",colKey:"cost",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"成本单价",colKey:"cost_price",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"最低限价",colKey:"min_price",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"挂牌价",colKey:"list_price",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"销售单价",colKey:"sales_price",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"销售金额",colKey:"sales_amount",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"采购金额",colKey:"purchase_amount",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"费用金额",colKey:"cost_amount",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"采购金额",colKey:"purchase_amount",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"成本费用",colKey:"cost",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"采购成本金额",colKey:"purchase_price",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"毛利",colKey:"margin",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"毛利率",colKey:"margin_rate",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"仓库",colKey:"warehouse",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"入库日期",colKey:"inbound_time",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"货权单位",colKey:"opening_company",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"赎单日",colKey:"redemption_day",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"是否开票",colKey:"rec",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"提单号",colKey:"bill_lading_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"合同号",colKey:"contract_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"货柜号",colKey:"container_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"销售人",colKey:"salesman_name",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"制单人",colKey:"creator_name",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"销售审核人",colKey:"auditor_name",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"出库审核人",colKey:"out_auditor_name",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"出库确认人",colKey:"out_operator_name",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"销售费用",colKey:"sales_avg_fee",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"税率",colKey:"tax_rate",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"税金",colKey:"tax_amount",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"实际销售单价",colKey:"sales_actual_price",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"属性",colKey:"attribute",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"仓储费金额",colKey:"warehouse_cost_amount",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"仓储费单价",colKey:"warehouse_cost",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"选色",colKey:"color",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"备注",colKey:"remark",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"备注1",colKey:"remark_1",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true}
                ],
                selectRow:[],
                totalObj:{},
                filterDialogVisible:false,
                filterdetailsVisible:false,
                filter:"",
                filters: [],
                fields:"",
                customerDialogVisibles:false,
                tableTotal:{
                    totalPrice:'',
                    tax_amount:'',
                    refundableAmount:'',
                },
                businessRelation: false,
                businessRelationForm: this.$cloneJson(initBusinessRelationForm),
                feeOutFormRlues: {
                    fee_date: [{required: true, message: '请填写日期', trigger: 'blur'}],
                    order_id: [{required: true, message: '请选择销售单号', trigger: 'blur'}],
                    fee_id: [{required: true, message: '请选择费用名称', trigger: 'blur'}],
                    payee: [{required: true, message: '请填写收款人', trigger: 'blur'}],
                    amount: [{required: true, message: '请填写金额', trigger: 'blur'}],
                    is_invoice: [{required: true, message: '请选择是否开票', trigger: 'blur'}],
                },
                detailInfo: {},
                outFeeSelect: [],
                newFee: [],
                expireTimeOption: {
                    disabledDate (date) {
                    // disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
                    return date.getTime() >= Date.now()
                    }
                },
                indetailType:"",

            }
        },
        methods:{
            headDrog(newWidth, oldWidth, column) {
                this.filters.forEach((item) => {
                    if (column.property == item.colKey) {
                        item.colWidth = newWidth;
                    }
                });
                let obj = {};
                obj.width = parseInt(newWidth);
                obj.name = column.property;
                let emit = ("changeHeadWidth" + 'return.create.column').replace(/\./g, "");
                bus.$emit(emit, obj);
            },
            sortList(e) {
                this.$generalSortParams(this.params, e);
                this.getList();
            },
            changeEdit(){
                this.$confirm('是否确认修改？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.changeData.out_time = this.formatTimeZero(this.changeData.out_time)
                    this.postFuncLoading("/erp/finance.update.price",this.changeData,()=>{
                        this.tip("修改成功","success")
                        this.dialogVisibleChange = false;
                        this.getList();
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            batchEdit(){
                if(this.selectRow.length<1){
                    this.tip("请选择数据","warning")
                    return;
                }else{
                    this.selectRow.forEach(item=>{
                        this.changeData.ids.push(item.id)
                    })
                    this.dialogVisibleChange = true;
                }
            },
            excelExport(){
                this.$exportExecl("/erp/export.sales.statistics","销售统计",this.params)
            },
            filterConfirm(){
                if(this.isGlobal){
                    this.getBillColumn()
                }else{
                    this.getList()
                }
            },
            getBillColumn(){
                this.filters = [];
                this.postFunc("/erp/company.column.data",{scene:this.scene},response=>{
                    this.billColumn = ","+response.data.data.fields.join(",").toString()+",";
                    this.filter = response.data.data.columns;
                    this.filters = response.data.data.columns;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getTableSummaries(params) {
                return this.$setSummaryFields(params, {
                    sales_cube:4,
                    out_cube:4,//出库立方
                    return_cube:4,
                    return_amount:2,
                    totalPrice:2,
                },total=>{
                });
            }, 
            openbusinessRelation(){
                // this.businessRelationForm.order_id = this.detailInfo.id;
                this.businessRelationForm.order_sn = this.form_params.order_sn;
                this.businessRelation = true;
                this.businessRelationForm.fee_date = new Date();
            },
            outFeeChange(e){
                this.outFeeSelect.forEach(item=>{
                    if(item.id==e){
                        this.businessRelationForm.fee_name = item.name;
                    }
                })
            },
            //获取费用名称
            outFeeSelectFunc(){
                this.postFunc("/erp/purchase.cost.type",{type:2},res=>{
                    this.outFeeSelect=res.data.data;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            //关联费用添加
            newOutFee(){
                for(let key in this.businessRelationForm){
                    if(this.businessRelationForm[key]==""){
                        if(key=="order_id"||key=="order_sn"||key=="remark"){
                            this.pl(key)
                        }else{
                            this.tip("请填写完整信息","warning")
                            return;
                        }
                    }
                }
                // let time = this.businessRelationForm.fee_date;
                this.businessRelationForm.fee_date=this.formatTimeZero(this.businessRelationForm.fee_date);
                this.newFee.push(JSON.parse(JSON.stringify(this.businessRelationForm)))
                this.businessRelation=!this.businessRelation;
            },
            //删除关联费用
            delOutFee(ind){
                this.newFee.forEach((item,index)=>{
                    if(index==ind){
                        this.newFee.splice(index,1)
                    }
                })
            },
            getSelectList(target){
                let obj = new Object();
                if(target=="user"){
                    obj.show_disabled = 1;
                }
                this.$getSelectList(target,obj).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            changeDetailTotalPrice(e,input){
                this.listDetail.forEach(item=>{
                    item.totalPrice=parseFloat(Number(item.return_cube)*Number(item.sales_price)).toFixed(2)
                })
                this.calculationTableTotal()
            },
            watchStock() {
                this.listDetail.map(a => {
                    a.return_cube = this.$digitInput(a.return_cube, 4);
                });
            },
            backConfirm(){
                this.$confirm('是否确认申请退货?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let data = JSON.parse(JSON.stringify(this.form_params));
                    data.detail_list = this.listDetail;
                    data.rec = data.rec==true?1:0;
                    data.fee_list = this.newFee;
                    data.return_time = this.formatTimeZero(data.return_time)
                    this.postFuncLoading("/erp/return.create",data,()=>{
                        this.tip('退货申请成功','success');
                        this.dialogVisible=false;
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            backPro(){
                if(this.selectRow.length<=0){
                    this.tip("请选择数据","warning")
                    return;
                }else{
                    let order_sn_first = this.selectRow[0].order_sn;
                    let flag = true;
                    this.selectRow.forEach(item=>{
                        if(item.order_sn!=order_sn_first){
                            flag = false;
                        }
                    })
                    if(flag){
                        this.scene = 'return.create.column';
                        this.isGlobal = true;
                        this.getBillColumn();
                        this.dialogVisible=true;
                        this.form_params.order_id=this.selectRow[0].order_id;
                        this.form_params.order_sn=this.selectRow[0].order_sn;
                        this.form_params.customer=this.selectRow[0].customer_name;
                        this.form_params.tax_rate=this.selectRow[0].tax_rate; 
                        this.form_params.rec_type=this.selectRow[0].rec_type; 
                        this.form_params.rec=this.selectRow[0].order_rec; 
                        if(this.form_params.rec==1){
                            this.form_params.rec = true
                        }
                        this.selectRow.forEach(item=>{
                            //item.order_detail_id=item.order_detail_id;
                            item.return_pieces=Number(item.pieces);
                            item.return_cube=Number(item.sales_cube);
                            item.totalPrice=this.keepPrice(this.$bc_mul(item.return_cube,item.sales_price))
                        })
                        let list = JSON.parse(JSON.stringify(this.selectRow));
                        this.listDetail = list;
                    }else{
                        this.tip("请选择同一销售单号数据","warning")
                    }
                }
            },
            getRow(row){
                this.selectRow=row;
            },
            reset(){
                this.sales_start = "";
                this.sales_end = new Date();
                // this.sales_start ="";
                // this.sales_end = "";
                this.out_start="";
                this.start_audit_time = "",
                this.end_audit_time = "",
                this.out_end="";
                this.params={search:{sales_start:"",sales_end:"",out_start:"",out_end:"",start_audit_time:"",end_audit_time:"",customer_id:"",salesman_id:"",original_bale:"",order_sn:"",breed_id:"",brand_id:"",grade_id:"",warehouse_id:"",bale_no:"",contract_no:"",bill_lading_no:"",ship_no:"",batch_no:"",remark:"",sales_length:"",sales_thickness:"",the_type:999},per_page: 50,page:1}
                this.$refs['selectdowncustomer'].clearData();
                this.getList()
            },
            customerCloses(){
                this.customerDialogVisibles = false;
            },
            Customerion(){
                this.getList();
                this.customerDialogVisibles = false;
                this.params.search.customer_name = '';
            },
            getList(flag){
                if(flag){
                    this.params.page = 1;
                }
                this.params.search.sales_start=this.formatTimeZero(this.sales_start);
                this.params.search.sales_end=this.formatTimeZero(this.sales_end);
                this.params.search.out_start=this.formatTimeZero(this.out_start);
                this.params.search.start_audit_time=this.formatTimeZero(this.start_audit_time);
                this.params.search.end_audit_time=this.formatTimeZero(this.end_audit_time);
                this.params.search.out_end=this.formatTimeZero(this.out_end);
                this.tableLoading = true;
                this.$postColumnList("/erp/sales.statistics",this.params,res=>{
                    this.last_page=parseInt(res.data.data.last_page);
                    // this.params.page=parseInt(res.data.data.current_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.total);
                    this.totalObj=res.data.data.statistics;
                    this.list=res.data.data.list;
                    this.list.forEach((item,index)=>{
                        if(item.out_time!=0){
                            this.list[index].out_time = this.formatTime(item.out_time+"000")
                        }else{
                            this.list[index].out_time = "";
                        }
                        if(item.sales_time!=0){
                            this.list[index].sales_time = this.formatTime(item.sales_time+"000")
                        }else{
                            this.list[index].sales_time = "";
                        }
                        if(item.audit_time!=0){
                            this.list[index].audit_time = this.formatTime(item.audit_time+"000")
                        }else{
                            this.list[index].audit_time = "";
                        }
                        if(item.inbound_time&&item.inbound_time!=0){
                            this.list[index].inbound_time = this.formatTimeSecond(item.inbound_time*1000) 
                        }else{
                            this.list[index].inbound_time ='';
                        }
                        this.list[index].thickness = this.keepLimit(item.thickness)
                        this.list[index].length = this.keepLimit(item.length)
                        this.list[index].the_type = item.the_type==1?"销售记录":"退货记录"
                    })
                    this.filter = res.data.data.column;
                    this.fields=","+(res.data.data.fields.join(",")).toString()+",";
                    this.tableCol.forEach(item=>{
                        if(this.fields.indexOf(","+item.colKey+",")!=-1){
                            item.isShow=true;
                        }else{
                            item.isShow=false;
                        }
                        // if(item.colKey=="status_str"){
                        //     if(this.fields.indexOf(",status,")!=-1){
                        //         item.isShow=true;
                        //     }
                        // }
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            rowClick(obj){
                if(obj.name=="sales_width_total"){
                    this.list.forEach(item=>{
                        if(item.id==obj.id){
                            this.widthList = item.sales_width;
                            this.saleDialogVisibleWidth = true;
                        }
                    })
                }
            },
            returnWidthClick(row,index){
                this.widthList = JSON.parse(JSON.stringify(row.return_width));
                this.returnDialogVisibleWidth=true;
                this.isreturnCanEditTotalWidth=true;
                if(row.category==2){
                    this.editReturn = true;
                }
                this.indetailType=index;
            },
            //退货总宽度返回
            returnWidthReturn(res){
                this.listDetail[this.indetailType].return_width=res;
                // 返回后总宽度计算
                let arr = this.listDetail[this.indetailType].return_width;
                //立方
                let newArr = arr.map(a=>{
                    return Number(a.cube)
                })
                let newCube = newArr.reduce(function(a, b){
                    if(b){
                        return a + b; 
                    }else{
                        return a
                    }
                }, 0); 
                //片数
                let piecesArr = arr.map(a=>{
                    return Number(a.pieces)
                })
                let newPieces = piecesArr.reduce(function(a, b){
                    if(b){
                        return a + b; 
                    }else{
                        return a
                    }
                }, 0);
                this.listDetail[this.indetailType].return_cube = newCube;//退货立方
                this.listDetail[this.indetailType].return_pieces = newPieces;//片数
                this.calculationTotalWidth(this.indetailType);
            },  
            //计算总宽度    
            calculationTotalWidth(){
                 let total = "";
                let countWidth = "";
                let layer_number = "";
                this.listDetail[this.indetailType].return_width.forEach((item,index)=>{
                    if(item.layer_number==undefined){
                        item.layer_number=''
                    }
                    //均宽余数有数据时，总宽度=（宽度明细合计/输入宽度个数）*层数+均宽余数、
                    let layer_number = JSON.parse(JSON.stringify(item.layer_number));
                    if(item.width_other==''||item.width_other==undefined){
                        total += !!item.width&&item.width.length>0?this.keepLimit(item.width.reduce((prev,next)=>this.keepLimit( Number(prev)+Number(next)))):"";
                        total += !!item.width&&item.width.length>0?",":"";
                    }else{//均宽余数有数据时，总宽度=（宽度明细合计/输入宽度个数）*层数+均宽余数
                        if(layer_number!=''){
                            total += !!item.width&&item.width.length>0?
                            this.rounding(this.$bc_add(this.$bc_mul(this.$bc_div(this.keepLimit(item.width.reduce((prev,next)=>this.keepLimit( Number(prev)+Number(next)))),item.width.length),item.layer_number),item.width_other))
                            :"";
                            total += !!item.width&&item.width.length>0?",":"";
                        }else{
                            total = item.width_other;
                            total += !!item.width&&item.width.length>0?",":"";
                        }
                    }
                })
                total = String((total.substring(0,total.length-1)));
                this.listDetail[this.indetailType].return_width_total = total;//退货立方
                this.changeDetailTotalPrice();
            },      
            //计算合计
            calculationTableTotal(){
                let totalPrice = 0;//退货金额
                let tax_amount = 0;//税金
                let refundableAmount = 0;//应退金额
                //退货金额
                totalPrice = this.keepPrices(this.$bc_add(...this.listDetail.map(a => a.totalPrice)));                
                let tax_rate = Number(this.form_params.tax_rate==''?0:this.$bc_div(this.form_params.tax_rate, 100));//税率
                if(this.form_params.rec_type==1){
                    tax_amount = this.keepPrices(this.$bc_mul(totalPrice,tax_rate));
                }else{
                    tax_amount = tax_rate==0?0:this.keepPrices(this.$bc_sub(this.$bc_div(totalPrice,this.$bc_sub(1, tax_rate)),totalPrice));
                }
                if(this.form_params.rec==true){
                    refundableAmount =  this.keepPrices(this.$bc_add(totalPrice,tax_amount));
                }else{
                    refundableAmount =  this.keepPrices(this.$bc_add(totalPrice,0));
                }
                this.tableTotal.totalPrice = totalPrice;
                this.tableTotal.tax_amount = tax_amount;
                this.tableTotal.refundableAmount = refundableAmount;
            },
            openSou(){
                this.customerDialogVisibles = true
            },
            getPage(obj){
                this.params.page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            },
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            },
            "form_params.rec": function () {
                this.calculationTableTotal();
            },
            "form_params.rec_type": function () {
                this.calculationTableTotal();
            },
            "form_params.tax_rate": function () {
                this.calculationTableTotal();
            },
            "dialogVisible":function(val){
                if(!val){
                    this.form_params.remark = '';
                     this.tableTotal={
                        totalPrice:'',
                        tax_amount:'',
                        refundableAmount:'',
                    }
                }else{ this.calculationTableTotal();}
            },
            "businessRelation":function(val){
                if(!val){
                    this.businessRelationForm = this.$cloneJson(initBusinessRelationForm);
                }
            },
            dialogVisibleChange:function(val){
                if(!val){
                    this.changeData = {ids:[],cube_price:"",sales_price:"",out_time:""}
                    this.out_time = new Date();
                }
            },
            "listDetail":{
                immediate:true,
                deep:true,
                handler() {
                    this.watchStock();
                }
            },
        }
    }
</script>
